// src/features/audit-monitor/services/auditFiltersService.js
import { map, filter, includes, get } from 'lodash';
import moment from 'moment';
import { SLA_TYPES, AUDIT_STATUS } from '../constants/auditConstants';

export class AuditFiltersService {
    static createSalesChannelItems(userSalesChannels, salesChannelsSelected = []) {
        const salesChannelItem = ({ id }) => ({
            id: parseInt(id),
            value: id,
            cm: id,
            slas: SLA_TYPES
        });

        const channelsToMap = salesChannelsSelected.length
            ? filter(userSalesChannels, ({ id }) => includes(salesChannelsSelected, id))
            : userSalesChannels;

        return map(channelsToMap, salesChannelItem);
    }

    static buildQueryFilters(filters, filtersApplied) {
        const { dateSelected, salesChannels } = filters;
        
        const dateRange = filtersApplied ? {
            init: `${moment(dateSelected.init).utc().format('YYYY-MM-DD')} 00:00:00`,
            end: `${moment(dateSelected.end).utc().format('YYYY-MM-DD')} 23:59:59`
        } : {
            init: `${moment().subtract(1, 'months').format('YYYY-MM-DD')} 00:00:00`,
            end: `${moment().add(1, 'days').format('YYYY-MM-DD')} 00:00:00`
        };

        const range = {
            filter: 'shippingETA.init',
            ...dateRange
        };

        const filtersSet = [
            { field: 'salesChannel', value: salesChannels },
            { field: 'status', value: get(filters, 'status', AUDIT_STATUS.PENDING_AUDIT.map(String)) }
        ];

        return {
            size: 100,
            filters: filtersSet,
            range,
            sort: [{ field: 'shippingETA.init', dir: 'asc' }]
        };
    }
}